(() => {
  const initializeSizeGuide = (dialog) => {
    if (dialog.dataset.sbSizeGuideInitialized === 'true') return;

    const dialogId = dialog.id;
    const openButton = document.querySelector(
      `[data-sb-size-guide-open][aria-controls="${dialogId}"]`,
    );
    const closeButton = dialog.querySelector('[data-sb-size-guide-close]');
    const unitButtons = dialog.querySelectorAll('[data-sb-size-unit]');
    const unitValues = dialog.querySelectorAll('[data-sb-size-value]');
    const touchPointer = window.matchMedia('(hover: none), (pointer: coarse)');

    if (!openButton || !closeButton) return;

    dialog.dataset.sbSizeGuideInitialized = 'true';
    let restoreFocus = false;
    let openedWithPointer = false;

    const closeGuide = () => {
      if (dialog.open) dialog.close();
    };

    const openGuide = () => {
      if (dialog.open) return;

      restoreFocus = !touchPointer.matches && !openedWithPointer;
      openedWithPointer = false;
      openButton.setAttribute('aria-expanded', 'true');
      dialog.showModal();

      if (restoreFocus) {
        window.requestAnimationFrame(() => closeButton.focus());
      }
    };

    const setUnit = (unit) => {
      unitButtons.forEach((button) => {
        const isActive = button.dataset.sbSizeUnit === unit;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      unitValues.forEach((value) => {
        value.hidden = value.dataset.sbSizeValue !== unit;
      });
    };

    openButton.addEventListener('pointerdown', () => {
      openedWithPointer = true;
    });

    openButton.addEventListener('keydown', () => {
      openedWithPointer = false;
    });

    openButton.addEventListener('click', openGuide);
    closeButton.addEventListener('click', closeGuide);

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setUnit(button.dataset.sbSizeUnit);

        if (touchPointer.matches) {
          window.requestAnimationFrame(() => button.blur());
        }
      });
    });

    const clearTouchFocus = (event) => {
      if (!touchPointer.matches) return;

      const control = event.target.closest('button, a');
      if (control) {
        window.requestAnimationFrame(() => control.blur());
      }
    };

    openButton.addEventListener('pointerup', clearTouchFocus);
    openButton.addEventListener('pointercancel', clearTouchFocus);
    dialog.addEventListener('pointerup', clearTouchFocus);
    dialog.addEventListener('pointercancel', clearTouchFocus);

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeGuide();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeGuide();
    });

    dialog.addEventListener('close', () => {
      openButton.setAttribute('aria-expanded', 'false');

      if (restoreFocus) {
        restoreFocus = false;
        openButton.focus();
      }
    });
  };

  const initializeAllSizeGuides = (root = document) => {
    root.querySelectorAll('[data-sb-size-guide-dialog]').forEach(initializeSizeGuide);
  };

  initializeAllSizeGuides();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllSizeGuides(event.target);
  });
})();
